(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-custom"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('restural-midnight-bar')) return;
  const nyDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  function nextMidnight(now) {
    const today = nyDate.format(now);
    let low = Math.floor(now / 1000);
    let high = low + 26 * 3600;
    while (high - low > 1) {
      const mid = Math.floor((low + high) / 2);
      if (nyDate.format(mid * 1000) === today) low = mid;
      else high = mid;
    }
    return high * 1000;
  }
  customElements.define('restural-midnight-bar', class extends HTMLElement {
    connectedCallback() {
      this.parts = ['hours','minutes','seconds'].map(key => this.querySelector('[data-' + key + ']'));
      if (this.parts.some(part => !part)) return;
      this.update = () => {
        const now = Date.now();
        if (!this.deadline || now >= this.deadline || now < this.previousNow) this.deadline = nextMidnight(now);
        this.previousNow = now;
        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
        this.parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
      };
      this.update();
      clearInterval(this.interval);
      this.interval = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
